var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviews(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15002_47350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4421 2.92617L12.9087 5.8595C13.1087 6.26783 13.6421 6.6595 14.0921 6.7345L16.7504 7.17617C18.4504 7.4595 18.8504 8.69283 17.6254 9.9095L15.5587 11.9762C15.2087 12.3262 15.0171 13.0012 15.1254 13.4845L15.7171 16.0429C16.1837 18.0679 15.1087 18.8512 13.3171 17.7929L10.8254 16.3179C10.3754 16.0512 9.63375 16.0512 9.17541 16.3179L6.68375 17.7929C4.90041 18.8512 3.81708 18.0595 4.28375 16.0429L4.87541 13.4845C4.98375 13.0012 4.79208 12.3262 4.44208 11.9762L2.37541 9.9095C1.15875 8.69283 1.55041 7.4595 3.25041 7.17617L5.90875 6.7345C6.35041 6.6595 6.88375 6.26783 7.08375 5.8595L8.55041 2.92617C9.35041 1.3345 10.6504 1.3345 11.4421 2.92617Z",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15002_47350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviews);
export default __webpack_public_path__ + "static/media/reviews.fa26cf6b617314f22daefa0cf6e18ed2.svg";
export { ForwardRef as ReactComponent };